import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import i18n from './locales'
import { initAnalytics, trackPageView } from './utils/analytics'

// 樣式導入
import 'element-plus/dist/index.css'
import './assets/styles/main.css'

// 創建應用實例
const app = createApp(App)

// 註冊插件
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(ElementPlus)

// 註冊 Element Plus 圖標
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 初始化營銷追蹤
initAnalytics({
  ga4Id: import.meta.env.VITE_GA4_ID,
  metaPixelId: import.meta.env.VITE_META_PIXEL_ID,
  debug: import.meta.env.DEV
})

// 路由追蹤
router.afterEach((to) => {
  trackPageView(to.path, to.meta.title as string)
})

// 掛載應用
app.mount('#app')